import React from 'react';
import { Control, API, Code, Name, Title, Actions, Form, Hooks, Files, Toast, Button, useListContext, useCallback, useEffect, useState, Utility } from 'helpers/ListImports';
import { Messages } from 'components/common/MessageManager';
import { Referral } from 'models/ReferralModel';


const ReferralList: React.FC = () => {
  const width = { client: 20, subject: 28, doctor: 20, recdoctor: 20, date:12 }
  const [formId, formName] = [Code.Form.Id.REFERRAL, Code.Form.Name.REFERRAL];
  const {loading, setLoading, error, setError, search, setSearch, pno, setPno, pageRows, setPageRow, activeId, setActiveId, selected, setSelected, confirm, setConfirm, message, setMessage,  showMenu, setShowMenu, selectedItems, setSelectedItems, selectAllChecked, setSelectAllChecked, activeOptions, setActiveOptions, rowOptions, setRowOptions, menuPosition, setMenuPosition, iframeRef, filterRef, contextMenuRef  } = useListContext();
  const [referralData, setReferralData] = useState<Referral[]>([]); 
  const [selectedReferral, setselectedReferral] = useState<Referral | null>(null);
  
  const triggers = [pno, pageRows, search, activeId];
  const Privilege = Hooks.Privilege.List(formId);
  const locationId = Utility.Storage.LocationId();

  Hooks.Privilege.HasView(Privilege);
  
  Form.Click.Outside([contextMenuRef, filterRef],[() => setShowMenu(false),() => {}],true);
  Form.Select.OnChange(selectedItems, setSelected);

  useEffect(() => {
    Files.Json.Http(Code.File.ACTIVE, Code.Option.Common.NOTHING, setActiveOptions, setError);
    Files.Json.Http(Code.File.ROW, Code.Option.Common.NOTHING, setRowOptions, setError);
  }, []);

  useEffect(() => {
    callListData(); 
  }, triggers);
 
  const callListData = useCallback(async () => {
    const url = API.Build.ListApiEndpoint(formName, pno, pageRows, Name.Referral.Id, Code.Option.Sort.DESC, activeId, search, {
      fields: Utility.Join.Fields([
        Name.Referral.Id, 
        Name.Referral.Date, 
        Name.Referral.Name, 
        Name.Client.Id, 
        Name.Client.FullName, 
        Name.Doctor.FullName, 
        Name.RecDoctor.FullName, 
      ]),
      ...(!Privilege.ALLLOC && { location_id: locationId }),
    });
     
    await API.Data.List<Referral>(url, setReferralData, setError, setLoading); 
  }, triggers);

  return (
    <Control.List.Frame>
      <Control.List.Panel>
        <Control.List.Tools>
          <Control.Tool.Left>
            <Button.Create title={formName} onClick={() => Form.Show.Popup(iframeRef, formName)} Privilege={Privilege} />
            {selected && ( <Button.Delete onClick={()=>Toast.Delete.MultipleRecords(activeId, selectedItems, setConfirm)} activeId={activeId} Privilege={Privilege} /> )}
          </Control.Tool.Left>
          <Control.Tool.Right>
            <Control.SearchBar onSearch={setSearch} onFilterToggle={() => Form.Show.Filter(filterRef)}  onGoClick={() => callListData()} />
            <Control.List.Filter filterRef={filterRef}>
              <Control.Dropdown title={Title.Status} value={activeId} options={activeOptions} onChange={setActiveId} />
              <Control.Dropdown title={Title.Rows} value={pageRows} options={rowOptions} onChange={setPageRow} />
            </Control.List.Filter>
            <Messages.Confirm Messages={confirm} onConfirm={() => API.Data.MultiDelete(formName, activeId, callListData, selectedItems, setConfirm, setMessage, setSelected, setSelectedItems, setError) } onRefuse={() => setSelectedItems([])} />
          </Control.Tool.Right>
        </Control.List.Tools>
        <Control.List.Data>
          <Control.List.Box>
            <Control.List.Title>
              <Control.SelectAll selectAllChecked={selectAllChecked} onSelectAll={(e) => Form.Select.All(e, setSelectedItems, referralData, setSelectAllChecked,formName)} extra={2} />
              <Control.Grid.Items values={[
                [Title.ClientName, width.client],
                [Title.Subject, width.subject],
                [Title.Doctor, width.doctor],
                [Title.RecDoctor, width.recdoctor],
                [Title.Date, width.date],
              ]} last={1} upper={true} />
            </Control.List.Title>
            {!loading && !error && Array.isArray(referralData) && (
              <Control.Grid.Row>
                {referralData.map((referralData) => { return (
                <Control.Grid.Data<Referral> key={referralData.referral_id} itemKey={referralData.referral_key} data={referralData} setMenuPosition={setMenuPosition} setSelectedData={setselectedReferral} setShowMenu={setShowMenu} >
                  <Control.Grid.Check keyId={referralData.referral_key} selectedItems={selectedItems} toggleSelection={Form.Select.Toggle} setSelectedItems={setSelectedItems} />
                  <Control.Grid.Modify path={Utility.Join.Edit(Privilege, formName, referralData.referral_key)} iframeRef={iframeRef} Privilege={Privilege} />
                  <Control.Grid.Print path={Utility.Join.Print(Privilege, formName, referralData.referral_key)} iframeRef={iframeRef} Privilege={Privilege} />
                  <Control.Grid.Link value={Utility.Get.FullName(referralData,Code.Form.Name.CLIENT)} path={Utility.Join.Edit(Privilege, Code.Form.Name.CLIENT, referralData.client_id)} width={width.client} iframeRef={iframeRef} />
                  <Control.Grid.Items values={[
                    [referralData.referral_name, width.subject], 
                    [Utility.Get.FullName(referralData,Code.Form.Name.DOCTOR), width.doctor],
                    [Utility.Get.FullName(referralData,Code.Form.Name.RECDOCTOR), width.recdoctor],
                    [Utility.Format.DateOnly(referralData.referral_date), width.date],
                  ]} />
                  <Control.Grid.Actions>
                    <Control.Action.All formName={formName} activeId={activeId} keyId={referralData.referral_key} iframeRef={iframeRef} setSelectedItems={setSelectedItems} setConfirm={setConfirm} Privilege={Privilege}><></></Control.Action.All>
                  </Control.Grid.Actions>
                </Control.Grid.Data>)})}
            </Control.Grid.Row>)}
          </Control.List.Box>
        </Control.List.Data>
        <Control.List.Info>
          <Control.RecordInfo pageNo={pno} pageRows={pageRows} loading={loading} error={error} dataLength={referralData.length} />
          <Control.Pagination pageNo={pno} onChange={(page) => setPno(page)} />
        </Control.List.Info>
      </Control.List.Panel>
      {showMenu && (<div ref={contextMenuRef}><Control.ListContextMenu showMenu={showMenu} formName={formName} onCreate={() => Form.Show.Popup(iframeRef, formName)} onModify={()=>Form.Show.Popup(iframeRef, Utility.Join.Edit(Privilege, formName, selectedReferral?.referral_key))} onDelete={() => Toast.Delete.SingleRecord(activeId, selectedReferral?.referral_key, setSelectedItems, setConfirm)} onClose={() => Form.Parent.TabClose()} setShowMenu={setShowMenu} Privilege={Privilege} pos={menuPosition} /></div>)}
      <Control.FormPopup iframeRef={iframeRef} onRefresh={callListData} />
      <Actions.List />
    </Control.List.Frame>
  );
};

export default ReferralList;